import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import { closeProjectModal } from '@store/slices/portfolioSlice';
const ModalOverlay = styled.div `
  display: ${props => props.isOpen ? 'flex' : 'none'};
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
`;
const ModalBackdrop = styled.div `
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.32);
  z-index: 1000;
  opacity: ${props => props.isOpen ? 1 : 0};
  transition: opacity 0.3s;
`;
const ModalContent = styled.div `
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.18);
  padding: 36px 32px 28px 32px;
  min-width: 320px;
  max-width: 480px;
  min-height: 180px;
  position: relative;
  z-index: 1001;
  opacity: ${props => props.isOpen ? 1 : 0};
  transform: ${props => props.isOpen ? 'scale(1)' : 'scale(0.7)'};
  transition: opacity 0.38s cubic-bezier(0.4, 2, 0.6, 1),
              transform 0.38s cubic-bezier(0.4, 2, 0.6, 1);
  pointer-events: auto;
  transition-delay: ${props => props.isOpen ? '0.18s' : '0s'};
`;
const CloseButton = styled.button `
  position: absolute;
  top: 12px;
  right: 18px;
  background: none;
  border: none;
  font-size: 2rem;
  color: #888;
  cursor: pointer;
  z-index: 1002;
  transition: color 0.2s;

  &:hover {
    color: #0a66c2;
  }
`;
const ModalBody = styled.div `
  margin-top: 18px;
  font-size: 1.08rem;
  color: #222;

  h3 {
    margin-bottom: 16px;
    color: #111;
  }
`;
const Modal = () => {
    const dispatch = useAppDispatch();
    const currentProjectModal = useAppSelector((state) => state.portfolio.currentProjectModal);
    const projects = useAppSelector((state) => state.portfolio.projects);
    const isOpen = !!currentProjectModal;
    const currentProject = projects.find(p => p.id === currentProjectModal);
    const handleClose = () => {
        dispatch(closeProjectModal());
    };
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };
    React.useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [isOpen]);
    return (_jsxs(ModalOverlay, { isOpen: isOpen, onClick: handleBackdropClick, children: [_jsx(ModalBackdrop, { isOpen: isOpen }), _jsxs(ModalContent, { isOpen: isOpen, children: [_jsx(CloseButton, { onClick: handleClose, children: "\u00D7" }), _jsx(ModalBody, { children: currentProject ? (_jsxs(_Fragment, { children: [_jsx("h3", { children: currentProject.title }), _jsx("p", { children: currentProject.details })] })) : (_jsxs(_Fragment, { children: [_jsx("h3", { children: "Project Details" }), _jsx("p", { children: "More info coming soon..." })] })) })] })] }));
};
export default Modal;
